/**
 * Required for every inquiry, in the order the form presents them.
 *
 * Every form asks the same questions now. The long field set used to add
 * organization and a free-text role/title; both were dropped, so `fields` no
 * longer changes what is required and this rule no longer branches on it.
 * Phone is offered on every form and required by none.
 */
const REQUIRED_FIELDS = [
    'audience',
    'firstName',
    'lastName',
    'email',
    'message',
];
/**
 * The required fields the visitor left blank, in form order. An empty array
 * means the inquiry is complete. Whitespace-only counts as blank.
 */
export function validateContactInquiry(inquiry) {
    return REQUIRED_FIELDS.filter((field) => !String(inquiry[field] ?? '').trim());
}
//# sourceMappingURL=contact-inquiry.js.map